import styled from "styled-components";
import {Breadcrumb} from "antd";

export const MyBreadcrumbStyles = styled.div`
  background: rgba(255, 255, 255, 1);
  height: 64px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  
  .edit-lesson{
    border-color: #AE7DD1;
    color: #AE7DD1;
  }
`